import React from "react";

const colorMap = {
  primary: {
    bg: "bg-primary/10",
    border: "border-primary/20",
    text: "text-primary",
    dot: "bg-primary",
  },
  secondary: {
    bg: "bg-secondary/10",
    border: "border-secondary/20",
    text: "text-secondary",
    dot: "bg-secondary",
  },
  tertiary: {
    bg: "bg-tertiary/10",
    border: "border-tertiary/20",
    text: "text-tertiary",
    dot: "bg-tertiary",
  },
  success: {
    bg: "bg-success/10",
    border: "border-success/20",
    text: "text-success",
    dot: "bg-success",
  },
  error: {
    bg: "bg-error/10",
    border: "border-error/20",
    text: "text-error",
    dot: "bg-error",
  },
  warning: {
    bg: "bg-warning/10",
    border: "border-warning/20",
    text: "text-warning",
    dot: "bg-warning",
  },
  neutral: {
    bg: "bg-on-surface/[.06]",
    border: "border-outline-variant",
    text: "text-on-surface-muted",
    dot: "bg-on-surface-muted",
  },
};

export default function Badge({
  color = "neutral",
  dot = false,
  pulse = false,
  children,
  className = "",
}) {
  const c = colorMap[color] || colorMap.neutral;

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full border text-[10.5px] font-medium ${c.bg} ${c.border} ${c.text} ${className}`}
    >
      {dot && <span className={`w-1 h-1 rounded-full ${c.dot} ${pulse ? "animate-pulse" : ""}`} />}
      {children}
    </span>
  );
}
